<!--
 * @Author: 李明明
 * @Date: 2023-12-13 15:52:29
 * @LastEditTime: 2024-05-17 10:59:32
 * @LastEditors: 李明明
 * @Description: 
 * @FilePath: /pc用户端/jctt-pc/src/App.vue
 * 代码版权方：'政府采购信息网'
-->
<template>
  <div id="app">
    <router-view :key="$route.fullPath" />
    <div class="service_wrap">
      <div class="qrcode_wrap">
        <div class="qrcode" ref="qrCodeUrl"></div>
        <p>微信扫一扫</p>
      </div>

      <div class="btn_wrap">
        <i class="iconfont icon-kefu"></i>
        <p>客服</p>
      </div>
    </div>
  </div>
</template>
<script>
import { setShareInfo, skip } from "@/utils/utils";
import QRCode from "qrcodejs2";
import { VersionChecker } from '@/utils/utils'

export default {
  data() {
    return {
      common_info: {
        store: {},
        qrCodeUrl: "",
      },
    };
  },
  methods: {
    // 生成客服二维码
    creatQrCode() {
      this.$nextTick(() => {
        this.$api
          .corp_wechat({})
          .then((res) => {
            console.log(res);
            let updataUrl = res.data.extInfo.url;
            //创建一个div，用来生成二维码
            let div = document.createElement("div");
            let qrcode = new QRCode(div, {
              text: updataUrl,
              width: 80, //图像宽度
              height: 80, //图像高度
              colorDark: "#000000", //前景色
              colorLight: "#ffffff", //背景色
              typeNumber: 1,
              correctLevel: QRCode.CorrectLevel.H,
            });

            let logo = new Image();
            logo.crossOrigin = "Anonymous";
            logo.src = require("@/assets/images/logo.png");
            //生成log图片
            logo.onload = () => {
              let container = this.$refs.qrCodeUrl;
              //获取页面上的div,可以document.querySelector()等等方法
              if (container.innerHTML != "") {
                //获取页面div，有则清除
                container.innerHTML = "";
              }
              //获取二维码
              let qrImg = qrcode._el.getElementsByTagName("img")[0];
              //获取canvas
              let canvas = qrcode._el.getElementsByTagName("canvas")[0];
              let cxt = canvas.getContext("2d");

              //写入logo
              // 定义背景颜色
              var backgroundColor = "white"; // 使用 CSS 颜色值表示

              // 绘制背景颜色
              cxt.fillStyle = backgroundColor; // 设置填充颜色
              cxt.fillRect(28, 28, 24, 24); // 绘制矩形区域
              cxt.drawImage(logo, 80 * 0.5 - 11, 80 * 0.5 - 11, 22, 22);
              qrImg.src = canvas.toDataURL();
              container.appendChild(qrcode._el);
            };

            qrcode.clear(); //清除二维码
            qrcode.makeCode(updataUrl); //生成另一个新的二维码
          })
          .catch((err) => {
            console.log(err);
          });
      });
    },
    getdata() {
      var that = this;
      this.$api
        .store()
        .then((res) => {
          if (res.code == 0) {
            // console.log(res)
            sessionStorage.setItem("appStore", JSON.stringify(res.data));
            document.title = res.data.store.name;
          }
        })
        .catch((err) => {
          this.common.message(this, err);
        });
    },
  },
  created() {
    this.getdata();
    let that = this;
    this.common.getCommonInfo(this, function() {
      /* that.ttshop_name = that.common_info.store.name;
      document.title = that.common_info.store.name; */
      var link =
        document.querySelector("link[rel*='icon']") ||
        document.createElement("link");
      link.type = "image/x-icon";
      link.rel = "shortcut icon";
      link.href = that.common_info.store.icon;
      document.getElementsByTagName("head")[0].appendChild(link);
    });

    // 获取分享人信息
    setShareInfo();
  },
  mounted() {
    this.creatQrCode();
    skip(window.location.href);
    // 使用对象参数方式调用，传入appName参数
    VersionChecker.checkVersion({
        refreshDelay: 1000     // 刷新延迟时间
    });
  },
};
</script>
<style lang="scss">
.service_wrap {
  cursor: pointer;
  font-size: 14px;
  position: fixed;
  text-align: center;
  z-index: 9999;

  right: 50px;
  bottom: 100px;
  .qrcode_wrap {
    display: none;

    vertical-align: bottom;
    padding: 10px;
    background: #ffffff;
    margin-right: 6px;
    p {
      margin-top: 8px;
    }
  }

  .btn_wrap {
    background: #dbd7d7;
    color: #ffffff;
    border-radius: 3px;
    padding: 12px;
    width: 40px;
    display: inline-block;
    vertical-align: bottom;
    p {
      margin-top: 4px;
    }
  }
  i {
    color: #000000;
  }
  &:hover {
    .qrcode_wrap {
      display: inline-block;
    }
  }
}
</style>
